module.exports = __webpack_public_path__ + "static/media/apollo.red.icon.5a80fde4.png";